import {
    Button,
    ModalBody,
    ModalDialog,
    ModalFooter,
    ModalHeader,
    ModalOverlay
} from '@flos/react-ui';
import type { CoverageTextItem } from '../../recoil/types/hippoTypes';
import { useHippoText } from '../../hooks/useHippoText';
import CoverageTable from './CoverageTable';

const CoverageTextModal = ({
    showModal,
    closeModal,
    coverageTextItem
}: {
    showModal: boolean;
    closeModal: () => void;
    coverageTextItem: CoverageTextItem;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const tableHeaderIncludedText = getHippoText('DSS-COVERAGE-MODAL-COVERS-HEADER');
    const tableHeaderExcludedText = getHippoText('DSS-COVERAGE-MODAL-DO-NOT-COVER-HEADER');

    return (
        <ModalOverlay
            isOpen={showModal}
            onDismiss={() => {
                closeModal();
            }}
        >
            <ModalDialog
                closeIconHandler={() => {
                    closeModal();
                }}
            >
                <ModalHeader title={coverageTextItem.title}>
                    <p className="u-spacing-inset-m--stretch-max">{coverageTextItem.subtitle}</p>
                </ModalHeader>
                <ModalBody>
                    {coverageTextItem.customerDescription && (
                        <p>{coverageTextItem.customerDescription}</p>
                    )}

                    <CoverageTable
                        included={coverageTextItem.included?.items}
                        excluded={coverageTextItem.excluded?.items}
                        includedTitle={tableHeaderIncludedText}
                        excludedTitle={tableHeaderExcludedText}
                    />
                </ModalBody>
                <ModalFooter className="u-text-left">
                    <Button
                        onClick={() => {
                            closeModal();
                        }}
                    >
                        Luk
                    </Button>
                </ModalFooter>
            </ModalDialog>
        </ModalOverlay>
    );
};

export default CoverageTextModal;
